// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* REPO PATH: src/front-end/code/app/Modal/modal.module.css
   REVERT-NOTE(unified-notify): NEW FILE — delete with app/Modal if reverting. */

.modal-module__overlay__z8ZMC {
    position: fixed;
    inset: 0;
    z-index: 2000;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
}

.modal-module__panel___UwVN {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);
    min-width: 280px;
    max-width: min(560px, 94vw);
    max-height: 86vh;
    display: flex;
    flex-direction: column;
}

.modal-module__header__a_jZX {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 14px;
    border-bottom: 1px solid #e5e7eb;
}

.modal-module__title__dk_HM {
    font-weight: 600;
    font-size: 0.95em;
}

.modal-module__close__GVKRo {
    background: none;
    border: none;
    font-size: 1.3em;
    line-height: 1;
    color: #666;
    cursor: pointer;
    padding: 0 2px;
}
.modal-module__close__GVKRo:hover { color: #000; }

.modal-module__body__wBkUQ {
    padding: 14px;
    overflow: auto;
}

.modal-module__footer__cumMz {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 10px 14px;
    border-top: 1px solid #e5e7eb;
}

/* Standard footer buttons for confirm-style modals */
.modal-module__btnSecondary__MiI5h {
    background: #f3f4f6;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    padding: 5px 14px;
    cursor: pointer;
    color: #374151;
}
.modal-module__btnSecondary__MiI5h:hover { background: #e5e7eb; }

.modal-module__btnPrimary__kt63w {
    background: #4a90d9;
    border: 1px solid #3a7bc0;
    border-radius: 4px;
    padding: 5px 14px;
    cursor: pointer;
    color: #fff;
}
.modal-module__btnPrimary__kt63w:hover { background: #3a7bc0; }

.modal-module__btnDanger__XDNA7 {
    background: #dc3545;
    border: 1px solid #b02a37;
    border-radius: 4px;
    padding: 5px 14px;
    cursor: pointer;
    color: #fff;
}
.modal-module__btnDanger__XDNA7:hover { background: #b02a37; }`, "",{"version":3,"sources":["webpack://./code/app/Modal/modal.module.css"],"names":[],"mappings":";;AAEA;gFACgF;;AAEhF;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;AAClB;AACA,oCAAe,WAAW,EAAE;;AAE5B;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,qDAAqD;AACrD;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;AACA,2CAAsB,mBAAmB,EAAE;;AAE3C;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;AACA,yCAAoB,mBAAmB,EAAE;;AAEzC;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;AACA,wCAAmB,mBAAmB,EAAE","sourcesContent":["\n\n/* REPO PATH: src/front-end/code/app/Modal/modal.module.css\n   REVERT-NOTE(unified-notify): NEW FILE — delete with app/Modal if reverting. */\n\n.overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 2000;\n    background: rgba(0, 0, 0, 0.45);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px;\n}\n\n.panel {\n    background: #fff;\n    border-radius: 8px;\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.35);\n    min-width: 280px;\n    max-width: min(560px, 94vw);\n    max-height: 86vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px 14px;\n    border-bottom: 1px solid #e5e7eb;\n}\n\n.title {\n    font-weight: 600;\n    font-size: 0.95em;\n}\n\n.close {\n    background: none;\n    border: none;\n    font-size: 1.3em;\n    line-height: 1;\n    color: #666;\n    cursor: pointer;\n    padding: 0 2px;\n}\n.close:hover { color: #000; }\n\n.body {\n    padding: 14px;\n    overflow: auto;\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    padding: 10px 14px;\n    border-top: 1px solid #e5e7eb;\n}\n\n/* Standard footer buttons for confirm-style modals */\n.btnSecondary {\n    background: #f3f4f6;\n    border: 1px solid #d1d5db;\n    border-radius: 4px;\n    padding: 5px 14px;\n    cursor: pointer;\n    color: #374151;\n}\n.btnSecondary:hover { background: #e5e7eb; }\n\n.btnPrimary {\n    background: #4a90d9;\n    border: 1px solid #3a7bc0;\n    border-radius: 4px;\n    padding: 5px 14px;\n    cursor: pointer;\n    color: #fff;\n}\n.btnPrimary:hover { background: #3a7bc0; }\n\n.btnDanger {\n    background: #dc3545;\n    border: 1px solid #b02a37;\n    border-radius: 4px;\n    padding: 5px 14px;\n    cursor: pointer;\n    color: #fff;\n}\n.btnDanger:hover { background: #b02a37; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `modal-module__overlay__z8ZMC`,
	"panel": `modal-module__panel___UwVN`,
	"header": `modal-module__header__a_jZX`,
	"title": `modal-module__title__dk_HM`,
	"close": `modal-module__close__GVKRo`,
	"body": `modal-module__body__wBkUQ`,
	"footer": `modal-module__footer__cumMz`,
	"btnSecondary": `modal-module__btnSecondary__MiI5h`,
	"btnPrimary": `modal-module__btnPrimary__kt63w`,
	"btnDanger": `modal-module__btnDanger__XDNA7`
};
export default ___CSS_LOADER_EXPORT___;
